import { get, getArrayBuffer } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  actions: {
     retrieveBusinessCustomerHabitation: (_, bCustomerId) =>
      get(`/report/business-customer-habitation/${bCustomerId}`),

    retrievePayrolls(_, { params } = {}) {
      return get(`ereporter/payrolls-export`, params).then(response => {
        return response;
      });
    },

    retrieveBuildingsAnalytics(_, { params } = {}) {
      return getArrayBuffer(`buildings-analytics`, params).then(response => {
        return response;
      });
    },

    retrieveEmergencyDevices() {
      return getArrayBuffer(`/report/emergency-devices`).then(response => {
        return response;
      });
    },

    retrieveTasks(_, { params } = {}) {
      return getArrayBuffer(`/report/tasks`, params).then(response => {
        return response;
      });
    },

    retrieveInvoices(_, { params } = {}) {
      return getArrayBuffer(`/report/invoices`, params).then(response => {
        return response;
      });
    },

    retrieveInvoicesAllLines(_, { params } = {}) {
      return getArrayBuffer(`/report/invoices-all-lines`, params).then(
        response => {
          return response;
      });
    },

    retrieveMedicall() {
      return getArrayBuffer(`/report/medicall`).then(response => {
        return response;
      });
    }
  }
};
